module.exports = __webpack_public_path__ + "assets/yumiya.66d41bef.png";